export function joinPaths(path1, path2) {
  const left = path1.endsWith('/') ? path1.slice(0, -1) : path1;
  const right = path2.startsWith('/') ? path2.slice(1, path2.length) : path2;
  return `${left}/${right}`;
}
